export const analyticsId = {
  TRANSFER_STEP_1_VIEW: 'TRANSFER_STEP_1_VIEW',
  TRANSFER_STEP_2_VIEW: 'TRANSFER_STEP_2_VIEW',
  TRANSFER_WIZARD_SUCCESS: 'TRANSFER_WIZARD_SUCCESS',
};

const commonFields = () => ({
  sectionFamily: 'banking',
  sectionCategory: 'services',
  sectionName: 'transfers',
  serviceType: 'transferTransactional',
  interactionType: 'funnel',
  processType: 'transfer',
});

export const getServiceTypeValue = (isImmediate) => {
  if (isImmediate === true) {
    return 'transferTransactionalImmediate';
  } else if (isImmediate === false) {
    return 'transferTransactionalStandard';
  }
  return 'transferTransactional';
}

export const catalogue = {
  [analyticsId.TRANSFER_STEP_1_VIEW]: () => ({
    ...commonFields(),
    event_name: 'step_details',
    pageName: '/transfers/step1/transferDetails',
    processStep: 'step1',
    processDetail: 'details',
  }),
  [analyticsId.TRANSFER_STEP_2_VIEW]: ({ isImmediate = null }) => ({
    ...commonFields(),
    serviceType: getServiceTypeValue(isImmediate),
    event_name: 'step_confirmation',
    pageName: '/transfers/step2/transferConfirmation',
    processStep: 'step2',
    processDetail: 'confirmation',
  }),
  [analyticsId.TRANSFER_WIZARD_SUCCESS]: ({ isImmediate = null }) => ({
    ...commonFields(),
    serviceType: getServiceTypeValue(isImmediate),
    event_name: 'step_success',
    pageName: '/transfers/success',
    processStep: 'success',
  }),
};
